/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Outlet } from 'react-router-dom';
import { BackNavigationView } from '../../components/back-navigation';
import { getAccountBackNavConfig } from '../../components/back-navigation/back-navigation-configs';
import { useBackNavigation } from '../../hooks/use-back-navigation';

const View = () => {
  const { primaryText, handleBack } = useBackNavigation(getAccountBackNavConfig);

  return (
    <>
      <BackNavigationView primaryText={primaryText} handleBack={handleBack} dataE2e="ztest-account-back-home" />
      <Outlet />
    </>
  );
};

export default View;
